import { createSlice } from '@reduxjs/toolkit';
import { storage } from '@/utils/storage';

const initialState = {
  list: storage.getJSON('planList', []),
};


export const slice = createSlice({
  name: 'plan',
  initialState,
  reducers: {
    updatePlanList: (state, action) => {
      state.list = action.payload;
      storage.set('planList', state.list);
    }
  }
});

const { reducer, actions } = slice;
export const { updatePlanList } = actions;
export default reducer;